import { observer } from 'mobx-react-lite';
import { modalStore } from 'entities/modal/model/modal.store';
import { ExampleModal } from 'features/exampleFeature/ui/ExampleModal';
import { ContentModal } from 'features/modal/ui/ContentModal';
import { TestDetailsModal } from 'features/modal/ui/TestDetailsModal';
import { Modal } from 'shared/ui/Modal';
import { NotificationModal } from 'features/modals/NotificationModal';
import { ChangePasswordModal } from '../../features/modals/ChangePasswordModal';
import { ContactModal } from '../../features/modals/ContactModal';

export const ModalProvider = observer(() => {
  if (!modalStore.isOpen) return null;

  const { modalType, modalProps } = modalStore;

  const renderModal = () => {
    switch (modalType) {
      case 'example':
        return <ExampleModal {...modalProps} />;

      case 'notification':
        return <NotificationModal {...modalProps} />;

      case 'changePassword':
        return <ChangePasswordModal {...modalProps} />;

      case 'contactModal':
        return <ContactModal {...modalProps} />;

      case 'testDetails':
        return <TestDetailsModal {...modalProps} />;

      // Content-like modals share the same component
      case 'privacyPolicy':
      case 'termsOfService':
      case 'newsletter':
      case 'offer': // <-- NEW
        return <ContentModal type={modalType} />;

      default:
        return null;
    }
  };

  // Custom dimensions for specific modals
  const getModalDimensions = () => {
    switch (modalType) {
      case 'contactModal':
        return {
          width: '800px',
          height: '500px',
          maxWidth: '800px',
        };
      case 'changePassword':
        return {
          width: '600px',
          height: '500px',
          maxWidth: '800px',
        };
      case 'testDetails':
        return {
          width: '900px',
          height: '600px',
          maxWidth: '95vw',
          maxHeight: '90vh',
        };
      default:
        return {};
    }
  };

  return (
    <Modal
      onClose={() => modalStore.closeModal()}
      customDimensions={getModalDimensions()}
    >
      {renderModal()}
    </Modal>
  );
});
